module.exports = __webpack_public_path__ + "img/img_body_biz_elice_logo.a5a3d300.png";